import type * as ents from '@attain-apps/entities'
import * as clipboard from '@attain-apps/fe/web/main/lib/clipboard'

/**
 * Used to copy and paste widgets.
 *
 * E.g., from one zone into another
 */
export class ClipboardItem extends clipboard.models
  .Item<ents.core.mosaic.Widget> {
  /** @inheritdoc */
  public override getName(): string {
    return this.payload.name
  }
}
